export * from '@platform/services/config/config.service';
export * from '@platform/services/config/config.types';
